import { Divider, Flex, Heading, Text, View } from "@aws-amplify/ui-react";

export default function DisclosurePage() {
  return (
    <Flex
      direction="column"
      minWidth={650}
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex>
        <View>
          <Text>
            This service does not provide or replace the consultation, guidance,
            or care of a healthcare professional or other qualified provider.
            This service provides a supplement for informational and educational
            purposes only. Healthcare professionals and other qualified
            providers should continue to consult authoritative records when
            making decisions. If you have any questions about this disclaimer,
            please contact us at info@totalcarecompass.com.
          </Text>
        </View>
      </Flex>
    </Flex>
  );
}
